export default "__VITE_ASSET__C$CFV_Gj__"